// (c) chaehongee. Confidential and proprietary.

type KnownParamKeys =
    | 'prompt_strength'
    | 'num_outputs'
    | 'num_inference_steps'
    | 'guidance_scale'
    | 'aspect_ratio'
    | 'resolution'
    | 'model'

type GenerationParamValue = number | string
type GenerationParams = Partial<Record<KnownParamKeys, GenerationParamValue>>

const DEFAULT_PARAMS: Required<Record<KnownParamKeys, GenerationParamValue>> = {
    prompt_strength: 0.8,
    num_outputs: 1,
    num_inference_steps: 28,
    guidance_scale: 3,
    aspect_ratio: 'auto',
    resolution: '1K',
    model: 'auto',
}

export function buildGenerationParamsTag(
    generation: GenerationParams
): string {
    const nonDefaultEntries = Object.entries(generation).filter(
        ([k, v]) =>
            v !== undefined &&
            (DEFAULT_PARAMS as any)[k as KnownParamKeys] !== v
    ) as Array<[KnownParamKeys, GenerationParamValue]>

    if (nonDefaultEntries.length === 0) return ''

    const body = nonDefaultEntries
        .map(([k, v]) => `${k}=${v}`)
        .join(',')
    return `\n\n<generation_params>\n${body}\n</generation_params>`
}


